import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing } = theme;

export const wrapper = css`
  margin: 0 0 ${spacing.xl}px 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 0 0 ${spacing.xxxl}px 0;
    `,
  )}
`;
